import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { IBasicAuthUserTokenPayload } from 'src/app/shared/constants/dfte-user-info';

@Injectable({
  providedIn: 'root',
})
export class loginService {
  nodeBaseUrl = DconConfigAPI.NODE_URL;
  userData: IBasicAuthUserTokenPayload | any;
  token = localStorage.getItem ('authToken');
  parsedToken=JSON.parse(this.token)


  constructor(private http: HttpClient) {}

  updatePassword(data,tokenpayload): Observable<any> {
    const token = tokenpayload
    const parsedToken=JSON.parse(token)
    console.log("token",parsedToken)
    
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${parsedToken}`
    });
   console.log("header",headers)
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.RESET_USER_PASSWORD;

    return this.http.post(url, data, { headers });
  }
  login(payload: { username: string; password: string }): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.LOGIN_USER;

    return this.http.post(url, payload, { headers });
  }
  logout(): Observable<any> {
    const token = localStorage.getItem('authToken');
    const parsedToken=JSON.parse(token)
   
    console.log('parsedtoken',parsedToken)
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${parsedToken}`
    });
console.log('headers',headers)
    const url = this.nodeBaseUrl + DconConfigAPI.URL_PROPS.LOGOUT_USER;

    return this.http.put(url, {},{ headers });
  }
}
